import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Highlighter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t bg-background">
      <div className="container py-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="space-y-4">
            <h3 className="text-lg font-bold">Camera Service Center</h3>
            <p className="text-sm text-muted-foreground">
              Serving Cameras, Building Trust – 40+ Years of Excellence
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground"
              >
                <Facebook className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                className="text-muted-foreground hover:text-foreground"
              >
                <Twitter className="h-5 w-5" />
              </a> */}
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground"
              >
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                className="text-muted-foreground hover:text-foreground"
              >
                <Linkedin className="h-5 w-5" />
              </a> */}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="grid grid-cols-2 gap-2">
              <li>
                <Link
                  to="/"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Adjustment Tools
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Testimonials
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            {/* <h4 className="text-sm font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services"
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Camera & Lens Repairs
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Sensor Cleaning
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm text-muted-foreground hover:text-foreground"
                >
                  Firmware Updates
                </Link>
              </li>
             
            </ul> */}
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="text-sm text-muted-foreground">
                <a
                  href="https://maps.app.goo.gl/bTkhqwJfNLEBagkNA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mount Road, Chennai
                </a>
              </li>
              <li className="text-sm text-muted-foreground">
                <a
                  href="https://maps.app.goo.gl/tvS4V3Qujfu4VhRX7"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kellys, Chennai
                </a>
              </li>
              <li className="text-sm text-muted-foreground">
                <a
                  href="https://maps.app.goo.gl/mwLRdakdx1c589C68"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mylapore, Chennai
                </a>
              </li>
              <li className="text-sm text-muted-foreground">
                <a
                  href="https://maps.app.goo.gl/ur7TEJFCNxEvMu4U8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Madurai
                </a>
              </li>
              <li className="text-sm text-muted-foreground">
                <a
                  href="https://maps.app.goo.gl/osF9xpVS1mg8NaAU9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Coimbatore
                </a>
              </li>
              {/* <li className="text-sm text-muted-foreground">
                Email: info@cameraservicecentre.in
              </li> */}
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} Camera Service Center. All rights
            reserved.
            <br />
            Designed and Managed by{" "}
            <a
              href="https://webniqueds.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Webnique Digital Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
